var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// libs
import React, { memo } from 'react';
// HOC
import withIconDefaults from './withIconDefaults';
function IconCopy(_a) {
    var { fillColor } = _a, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 20 20", fill: "none" }, props),
        React.createElement("path", { d: "M15.2494 16.7811H4.41602C4.08268 16.7811 3.79102 16.6561 3.54102 16.4061C3.29102 16.1561 3.16602 15.8644 3.16602 15.5311V2.19775C3.16602 1.86442 3.29102 1.57275 3.54102 1.32275C3.79102 1.07275 4.08268 0.947754 4.41602 0.947754H11.666L16.4994 5.78109V15.5311C16.4994 15.8644 16.3744 16.1561 16.1244 16.4061C15.8744 16.6561 15.5827 16.7811 15.2494 16.7811ZM11.041 6.32275V2.19775H4.41602V15.5311H15.2494V6.32275H11.041ZM1.91602 19.2811C1.58268 19.2811 1.29102 19.1561 1.04102 18.9061C0.791016 18.6561 0.666016 18.3644 0.666016 18.0311V5.13525H1.91602V18.0311H12.291V19.2811H1.91602Z", fill: fillColor })));
}
export default memo(withIconDefaults(IconCopy));
